module.exports = __webpack_public_path__ + "img/guide_05.70034782.png";